var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReadNotificationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    rx: 7,
    fill: "#F8F6FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 237675"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1032",
    d: "M15.0303 29.9408L16.7229 23.0011C17.457 20.6591 18.3608 18.8513 19.5823 17.6305C20.7807 16.4327 22.3345 15.75 24.5 15.75C26.6655 15.75 28.2193 16.4327 29.4177 17.6305C30.6392 18.8513 31.543 20.6591 32.2771 23.0011L33.9697 29.9408C34.0081 30.0982 33.8888 30.25 33.7268 30.25H15.2732C15.1112 30.25 14.9919 30.0982 15.0303 29.9408Z",
    fill: "white",
    fillOpacity: 0.1,
    stroke: "#39414A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1033",
    d: "M28.3 30C28.3 32.2091 26.5092 34 24.3 34C22.0909 34 20.3 32.2091 20.3 30",
    stroke: "#39414A",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1034",
    d: "M27.3999 16C27.3999 14.3431 26.0568 13 24.3999 13C22.743 13 21.3999 14.3431 21.3999 16",
    stroke: "#39414A",
    strokeWidth: 1.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadNotificationIcon);
export default __webpack_public_path__ + "static/media/readNotificationIcon.0d750874b291c5c63cbee6b522bd44aa.svg";
export { ForwardRef as ReactComponent };